import { mapActions, mapGetters, mapMutations } from "vuex";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import listClient from "./components/list-client/index.vue";
export default {
    name: "agent-clients",
    data() {
        return {
            secondAddresses: [],
            payload: {
                active: 0,
                city: "",
                street: "",
                house: "",
                flat: "",
            },

            showLoader: false,
            validationErrors: {},
        };
    },
    components: {
        listClient,
    },
    validations() {
        return {
            payload: {
                city: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(30),
                },
                street: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(50),
                },
                house: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                flat: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                active: {},
            },
        };
    },
    created() {
        // for (let i in this.user.addresses) {
        if (this.user.agent_status === 2) {
            this.fetchAgentClients().then(() => {
                // console.log(this.agentClients);
            });
        }
        // }
    },
    // watch:{
    //   user: function (newVal) {
    //     if (newVal) {
    //       this.secondAddresses=[]
    //       for (let i in this.user.addresses) {
    //         if (this.user.addresses[i].active === 0) {
    //           this.secondAddresses.push(this.user.addresses[i]);
    //         }
    //       }
    //     }
    //   },
    // },
    computed: {
        ...mapGetters({
            user: "profile/user",
            agentClients: "profile/agentClients",
        }),
        // getMainAddress() {
        //   for (let i in this.user.addresses) {
        //     if (this.user.addresses[i].active === 1) {
        //       return this.user.addresses[i];
        //     }
        //   }
        // },
    },
    methods: {
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            fetchAgentClients: `profile/GET_AGENT_CLIENTS`,
            deleteUserAddress: `profile/REMOVE_USER_ADDRESS`,
            deleteAgentClient: `profile/REMOVE_AGENT_CLIENT`,
        }),
        ...mapMutations({
            changePopupMainAddress: `profile/CHANGE_POPUP_MAIN_ADDRESS`,
            setAgentClients: `profile/SET_AGENT_CLIENTS`,
        }),
        removeClient(item) {
            let obj = {};
            obj.id = item.id;
            this.deleteAgentClient(obj)
                .then(() => {
                    this.$toasted.success(this.$t("youClientRemove"));
                    this.fetchAgentClients();
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        console.log(error.response);
                    }
                });
        },
    },
};
